import React, { useEffect, useState } from "react";
import { Box, Button, Link, Text } from "@chakra-ui/react";
import useHashConnect from "hooks/useHashConnect";
import { checkIfMaintainanceOverDay, getTimeStamp } from "utils";

function TimerModal() {
  const { maintainanceData } = useHashConnect();

  const { startTime, endTime } = maintainanceData;
  const [mtStartHr, mtStartMin] = startTime.split(":").map(Number);
  const [mtEndHr, mtEndMin] = endTime.split(":").map(Number);
  const mtIsOverDay = checkIfMaintainanceOverDay(
    mtStartHr,
    mtStartMin,
    mtEndHr,
    mtEndMin
  );
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const updateDateTime = async () => {
    const timestamp = await getTimeStamp();
    if (!timestamp) {
      return;
    }
    const date = new Date(timestamp * 1000);
    date.setUTCMilliseconds(0);
    const hour = date.getUTCHours();

    const endDate = new Date();
    endDate.setUTCMilliseconds(0);

    endDate.setUTCHours(mtEndHr);
    endDate.setUTCMinutes(mtEndMin);
    endDate.setUTCSeconds(59);
    if (mtIsOverDay && hour >= mtStartHr) {
      endDate.setDate(endDate.getDate() + 1);
    }
    const difference = Math.abs(endDate.getTime() - date.getTime());
    const diffMins = Math.floor(difference / 60000);
    var diffSeconds = Math.abs(difference / 1000 - diffMins * 60);
    setMinutes(diffMins);
    diffSeconds === 0 ? setSeconds(diffSeconds + 1) : setSeconds(diffSeconds);
  };

  useEffect(() => {
    updateDateTime();
  }, []);

  useEffect(() => {
    const timer = setTimeout(function () {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearTimeout(timer);
          return;
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
      if (seconds % 5 === 0) {
        updateDateTime();
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [seconds]);
  return (
    <Box>
      <Text
        fontSize="28px"
        fontWeight="400"
        display="flex"
        justifyContent="center"
        marginBottom="0px"
      >
        Syncing
      </Text>
      <Text
        fontSize="56px"
        fontWeight="600"
        display="flex"
        justifyContent="center"
        marginTop="40px"
        marginBottom="25px"
      >
        {minutes < 10 ? `0${Math.trunc(minutes)}` : Math.trunc(minutes)}:
        {seconds < 10 ? `0${Math.trunc(seconds)}` : Math.trunc(seconds)}
      </Text>
      <Text
        fontSize="16px"
        fontWeight="400"
        color="#8F8F8F"
        display="flex"
        justifyContent="center"
        marginBottom="0px"
      >
        minutes to go
      </Text>

      {minutes === 0 && seconds === 0 ? (
        <Box display="flex" justifyContent="center" marginTop="24px">
          <Link href="/">
            <Button bg="brand.primary" color="brand.textLight">
              Reload
            </Button>
          </Link>
        </Box>
      ) : (
        <Text
          display="flex"
          justifyContent="center"
          color="#8F8F8F"
          fontSize="1rem"
          marginTop="28px"
        >
          Dapp unavailable: Sync with protocol staking rewards in progress
        </Text>
      )}
    </Box>
  );
}

export default TimerModal;
